// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".activation[data-v-310c6960]{padding:0 20px}.activation[data-v-310c6960] .txt{font-weight:500;margin-bottom:30px}", "",{"version":3,"sources":["webpack://./resources/js/pages/Telephony/Activation.vue"],"names":[],"mappings":"AACA,6BACI,cAAA,CAGA,kCACI,eAAA,CACA,kBAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
